const mapRefundMethod = refundMethod => {
  return {
    id: refundMethod.id,
    name: refundMethod.name,
    position: refundMethod.position,
    display: refundMethod.display,
    is_enabled: refundMethod.is_enabled,
    instant_allowed: refundMethod.instant_allowed,
    enabled_for_refunds: refundMethod.enabled_for_refunds,
    enabled_for_exchanges: refundMethod.enabled_for_exchanges,
    enabled_for_reveni_exchange: refundMethod.enabled_for_reveni_exchange,
    duration: refundMethod.duration,
    extra_value: refundMethod.extra_value,
    extra_value_type: refundMethod.extra_value_type,
    min_eligible_refund_amount: refundMethod.min_eligible_refund_amount,
    max_extra_amount: refundMethod.max_extra_amount,
    allow_extra_when_paid_with_credit: refundMethod.allow_extra_when_paid_with_credit,
    discount_combinations: refundMethod.discount_combinations,
  }
}

const mapRefundMethodConfiguration = refundMethod => {
  const { id: _id, ...refundMethodConfiguration } = mapRefundMethod(refundMethod)

  return refundMethodConfiguration
}

export const transformResponsePortalRefundMethods = refundMethods => {
  return { refund_methods: refundMethods.map(mapRefundMethod), enabled_stores: [], enabled_portals: [] }
}

export const transformResponseMerchantRefundMethods = data => {
  return {
    refund_methods: data.refund_methods.map(mapRefundMethod),
    enabled_stores: data.enabled_stores,
    enabled_portals: data.enabled_portals,
  }
}

export const transformRequestRefundMethodsConfiguration = ({ returnPortalId, merchantId, configuration }) => {
  return {
    returnPortalId,
    merchantId,
    configuration: {
      issue_refund_at_status: configuration.issue_refund_at_status,
      refund_methods: configuration.refund_methods.map(mapRefundMethodConfiguration),
    },
  }
}
